import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AuthState } from 'src/app/store/auth/auth.state';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  error: string;
  errorDescription: string;
  errorDetails: string;
  icon = 'error';
  cssClass = '';
  showUpgradeButton = false;
  billingRoute = '/billing';

  constructor(activatedRoute: ActivatedRoute, private store: Store, private location: Location, private translate: TranslateService) {
    const error = activatedRoute.snapshot.params['error'] || activatedRoute.snapshot.data.error;
    this.error = `errors.${error}`;
    this.errorDescription = `errors.${error}Description`;
    if (error === 'upgrade') {
      this.error = 'pricingLimit.upgrade';
      this.icon = 'announcement';
      this.cssClass = 'white-bg';
      const company = this.store.selectSnapshot(AuthState.company);
      if (company.role === 'owner') {
        this.showUpgradeButton = true;
      } else {
        this.error = 'pricingLimit.upgradeNotOwner';
        this.errorDetails = 'pricingLimit.upgradeAskOwner';
      }
    }
  }

  get isDescriptionAvailable(): boolean {
    const translated = this.translate.instant(this.errorDescription);
    return !!translated && translated !== this.errorDescription;
  }

  get isUnauthorized(): boolean {
    return this.error === 'errors.unauthorized';
  }

  get isPageNotFound(): boolean {
    return this.error === 'errors.pageNotFound';
  }

  get svgIcon(): string | null {
    if (this.isUnauthorized) return 'security_lock';
    if (this.isPageNotFound) return 'info_warning';
    return null;
  }

  get hasSvgIcon(): boolean {
    return !!this.svgIcon;
  }

  get dashboardRoute(): string {
    const company = this.store.selectSnapshot(AuthState.company);
    return company?.role === 'user' ? '/dashboard-individual' : '/dashboard';
  }

  onBack() {
    this.location.back();
  }

}
